/* eslint-disable @typescript-eslint/no-non-null-assertion */
import * as React from "react";
import Markdown from "components/Markdown/index";
import FormSection from "../form/Sections/FormSection";
import * as _ from "lodash";
import { ControlType, TenantVariableTemplateResource } from "client/resources";
import TenantVariableInput, { TenantVariableInputProps } from "./TenantVariableInput";
type HelpTextMarkupProvider = (label: string) => string;

// The purpose of this class is to provide consistent labels/help text etc for components that are external to the actual input
export default class TenantVariableInputFormElement extends React.Component<TenantVariableInputProps, never> {
    shouldComponentUpdate(newProps: TenantVariableInputProps) {
        return hasParameterChanged(newProps, this.props);
    }

    render() {
        const parameter = this.props.variableTemplate;
        const label = getLabel(parameter);
        return (
            <FormSection title={label} help={getHelpText(parameter)}>
                <TenantVariableInput {...this.props} />
            </FormSection>
        );
    }
}

function hasParameterChanged(newParam: TenantVariableInputProps, oldParam: TenantVariableInputProps): boolean {
    return !_.isEqual(newParam.value, oldParam.value) || !_.isEqual(newParam.error, oldParam.error) || !_.isEqual(newParam.warning, oldParam.warning) || !_.isEqual(newParam.sourceItems, oldParam.sourceItems);
}

function getLabel(parameter: TenantVariableTemplateResource) {
    return parameter.Label || parameter.Name;
}

function getHelpText(parameter: TenantVariableTemplateResource, customEmptyHelpTextMarkup: HelpTextMarkupProvider = null!, packageParameterIsUsed?: boolean) {
    const label = parameter.Label || parameter.Name;
    const helpText = parameter.HelpText
        ? parameter.HelpText
        : customEmptyHelpTextMarkup
        ? customEmptyHelpTextMarkup(label)
        : parameter.DisplaySettings["Octopus.ControlType"] !== ControlType.Package || packageParameterIsUsed
        ? `Provide a value for ${label}`
        : "";
    return <Markdown markup={helpText} />;
}

export { hasParameterChanged, getLabel, getHelpText };
